import React, { useEffect } from 'react';
import { identity } from 'ramda';
import { Loader } from 'js/components/common/Loader';
import { usePortletConfig, usePortletDispatch, withPortlet, withPortletFetch } from 'js/components/system/Portlet';
import { useResponsibleGaming } from 'js/components/system/App/hooks';
import { noop } from 'js/utils/methods.util';
import { Empty } from './components/Empty';

export const SET_CONFIG = 'SET_CONFIG';

export const setConfigAction = config => ({
    type: SET_CONFIG,
    payload: {
        config
    }
});

export const useDefaultParams = () => ({ type: usePortletConfig().portletType });

export default options => (PortletComponent) => {
    const {
        fetch,
        useParams = useDefaultParams,
        onResponse,
        onError,
        isLimitEnabled = noop,
        parseConfig = identity,
        ...withPortletOptions
    } = options;

    const Wrapped = withPortletFetch({
        fetch,
        useParams,
        onResponse,
        onError
    })(PortletComponent);

    return withPortlet(withPortletOptions)((props) => {
        const dispatch = usePortletDispatch();
        const { portletType } = usePortletConfig();
        const [isFetching, config, cmsConfig] = useResponsibleGaming(portletType);

        useEffect(() => {
            if (config) {
                dispatch(setConfigAction(parseConfig({
                    ...config,
                    ...cmsConfig
                })));
            }
        }, [config, cmsConfig, dispatch]);

        if (isFetching) {
            return <Loader />;
        }

        if (config && !isLimitEnabled(config, portletType)) {
            return <Empty />;
        }

        if (!config) {
            return null;
        }

        return <Wrapped {...props} />;
    });
};
